import { createContext } from 'react';
var initialContext = {
    isLoading: true,
    roles: [],
    reload: function () { return Promise.resolve(); },
};
export var RolesContext = createContext(initialContext);
